// Decides what happens after the per-channel queue attempts in
// ViewMessage.send(): total failure (halt, nothing queued), partial failure
// (one channel queued, the other didn't — surface it but still send), or
// success. Pure so the channel/outcome matrix can be unit tested.
export const resolveQueueOutcome = ({
  totalTxts,
  totalEmails,
  textQueued,
  emailQueued,
  queueErrorReasons = [],
}) => {
  if (!textQueued && !emailQueued) {
    return {
      outcome: 'totalFailure',
      status: 'failed',
      proceedWithSend: false,
      errorMessage: `There was an error sending your message.${
        queueErrorReasons.length ? ` ${queueErrorReasons.join(' ')}` : ''
      }`,
    };
  }

  if (totalTxts > 0 && !textQueued) {
    return {
      outcome: 'partialText',
      status: 'finished',
      proceedWithSend: true,
      errorMessage:
        'Message processed. Note: There was an error queuing one or more texts.',
    };
  }

  if (totalEmails > 0 && !emailQueued) {
    return {
      outcome: 'partialEmail',
      status: 'finished',
      proceedWithSend: true,
      errorMessage:
        'Message processed. Note: There was an error queuing one or more emails.',
    };
  }

  return {
    outcome: 'success',
    status: 'finished',
    proceedWithSend: true,
    errorMessage: null,
  };
};
